const checkboxSkin = {
  checkbox: {
    "margin-right": "10px",
  },
};

export default checkboxSkin;
